(() => {
  'use strict';

  if (location.pathname.replace(/\/$/, '') !== '/search') return;

  const LOGO = 'https://cdn.shopify.com/s/files/1/0766/4051/8479/files/selective-logo.webp?v=1723533398';
  const BADGE = 'pw-search-selective-badge';
  let selectivePaths = new Set();

  const pathOf = (value) => {
    try { return new URL(value, location.origin).pathname.replace(/\/$/, '').toLowerCase(); }
    catch (_) { return String(value || '').split('?')[0].replace(/\/$/, '').toLowerCase(); }
  };

  const styles = () => {
    if (document.getElementById('pw-search-selective-styles')) return;
    const el = document.createElement('style');
    el.id = 'pw-search-selective-styles';
    el.textContent = `
      .pw-search-product-card__media,.pw-search-quick__media{position:relative}
      .${BADGE}{position:absolute;top:10px;left:10px;z-index:4;display:inline-flex;min-height:32px;align-items:center;gap:6px;padding:3px 7px 3px 6px;border:1px solid rgba(16,24,40,.14);border-left:3px solid #ed0e0e;border-radius:2px;background:rgba(255,255,255,.97);box-shadow:0 1px 3px rgba(16,24,40,.06);pointer-events:none}
      .${BADGE}__logo{display:block!important;width:auto!important;height:20px!important;max-width:62px!important;object-fit:contain!important}
      .${BADGE}__years{color:#111827;font-size:10px;font-weight:800;line-height:1.05;white-space:nowrap}
      .pw-search-quick__media .${BADGE}{top:3px;left:3px;min-height:21px;gap:0;padding:2px 3px;border-left-width:2px}
      .pw-search-quick__media .${BADGE}__logo{height:12px!important;max-width:36px!important}
      .pw-search-quick__media .${BADGE}__years{display:none}
      @media(max-width:620px){.pw-search-product-card__media .${BADGE}{top:7px;left:7px;min-height:27px;gap:4px;padding:2px 5px 2px 4px}.pw-search-product-card__media .${BADGE}__logo{height:16px!important;max-width:50px!important}.pw-search-product-card__media .${BADGE}__years{display:none}}
    `;
    document.head.append(el);
  };

  const createBadge = () => {
    const badge = document.createElement('span');
    badge.className = BADGE;
    badge.setAttribute('aria-label', 'Beko Selective, 5 jaar garantie');
    const logo = document.createElement('img');
    logo.className = `${BADGE}__logo`;
    logo.src = LOGO;
    logo.alt = '';
    logo.loading = 'lazy';
    logo.width = 70;
    logo.height = 29;
    const years = document.createElement('span');
    years.className = `${BADGE}__years`;
    years.textContent = '5 jaar garantie';
    badge.append(logo, years);
    return badge;
  };

  const decorate = () => {
    if (!selectivePaths.size) return;
    document.querySelectorAll('.pw-search-product-card > a[href],.pw-search-quick__link[href]').forEach((link) => {
      if (!selectivePaths.has(pathOf(link.href))) return;
      const media = link.querySelector('.pw-search-product-card__media,.pw-search-quick__media');
      if (media && !media.querySelector(`.${BADGE}`)) media.append(createBadge());
    });
  };

  const fetchPage = async (base, page) => {
    const url = new URL(base, location.origin);
    url.searchParams.set('page', String(page));
    url.searchParams.set('_pw_selective', `${Date.now()}-${page}`);
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`search index ${response.status}`);
    return response.json();
  };

  const load = async () => {
    const root = document.querySelector('[data-pw-predictive-search]');
    const base = root?.dataset.searchIndexUrl || '/collections/all?view=pw-search-index';
    const first = await fetchPage(base, 1);
    const pages = Math.max(1, Number(first.pages || 1));
    const requests = [];
    for (let page = 2; page <= pages; page += 1) requests.push(fetchPage(base, page));
    const payloads = [first, ...(await Promise.all(requests))];
    selectivePaths = new Set(
      payloads.flatMap((payload) => payload.products || [])
        .filter((product) => product?.selective === true && String(product.vendor || '').trim().toLowerCase() === 'beko' && product.url)
        .map((product) => pathOf(product.url))
    );
    decorate();
  };

  const start = () => {
    styles();
    new MutationObserver(decorate).observe(document.documentElement, { childList: true, subtree: true });
    load().catch(() => {});
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
